<div class="@container/workarea h-screen">
    <div class="p-4 overflow-auto h-[calc(100vh-70px)]" [ngClass]="{'h-screen': !hasChanges }">
        <form novalidate="" class="gap-6" #productTranslationForm="ngForm">    
            <div class="card p-4 mb-4">
                <h2 class="form-section-title">Oversættelse</h2>
            @for(lang of languages; track lang.CultureCode)
            {
                <section class="form-section mb-8">
                    <div class="space-y-4">
                        <div class="form-row">
                            <div class="form-row-info">
                                <h3 class="form-row-title">
                                    Navn ({{lang.Name}})
                                </h3>
                                <p class="form-row-description">
                                    OBS! Skal oversættes.<br />
                                    Varens farve skal ikke indgå i navnet, da det kommer på hjemmesiden via farvekoden
                                </p>
                            </div><!---->
                            <div class="form-row-input">
                                <div class="w-full">
                                    <input type="text" class="input bg-white" placeholder="Navn" [(ngModel)]="getName(lang.CultureCode).Data" name="name_{{lang.CultureCode}}" />
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-row-info">
                                <h3 class="form-row-title">
                                    Beskrivelse ({{lang.Name}})
                                </h3>
                                <p class="form-row-description">
                                    OBS! Skal oversættes.<br />
                                    På nye varer indsættes varens navn også i dette felt. Navnet gøres fed i dette felt.
                                </p>
                            </div>
                            <div class="form-row-input">
                                <div class="w-full">
                                <app-rich-text-editor [(ngModel)]="getDescription(lang.CultureCode).Data" name="description_{{lang.CultureCode}}">
                                </app-rich-text-editor>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>        
            }
            </div>
        </form>
    </div>
    @if(hasChanges)
    {
     <div class="content-footer">
        <div class="content-footer-inner-wrap">
            <div class="content-footer-left-content"></div>
            <div clasS="content-footer-right-content">
                <button type="button" class="btn btn-default" (click)="cancel()">Discard changes</button>
                <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!hasChanges">
                    Save changes
                    @if (working)
                    {
                    <div class="ml-2 w-4 h-4 border-2 border-white-500 border-t-transparent rounded-full animate-spin"></div>
                    }
                </button>
            </div>
        </div>
    </div>
    }
</div>
